<template>
    <div class="configuration-diagram">
        <div class="left">
            <el-tree id="tree" ref="tree" :data="treeData" :props="props" :current-node-key="depId"
                :default-expanded-keys="expandedKeys" highlight-current node-key="id" @node-click="handleNodeClick"
                :render-content="renderContent" />
        </div>
        <div class="right">
            <div v-if="currentSvgUrl" id="svgContainer" ref="svgContainer" class="svg-wrapper">
            </div>
            <noData v-else style="
                height: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
            "></noData>
            <!--设备详情-->
            <device-detail :distribution-style="true" ref="deviceDetail"></device-detail>
        </div>

        <!-- Add dialog component for SVG preview -->
        <el-dialog
            title="SVG 预览"
            :visible.sync="dialogVisible"
            custom-class="svg-dialog-large"
            :before-close="handleDialogClose"
            width="80%">
            <div id="dialogSvgContainer" ref="dialogSvgContainer" style="width:100%;height:600px;overflow:hidden;"></div>
        </el-dialog>
    </div>
</template>

<script>
import { getSpaceTreeDataSystemType } from "@/network/power-wiring-diagram";
import { getDataByDeviceIdsAndPointIds } from "@/network/device-topology";
import Panzoom from "panzoom";
import noData from "@/components/NoData";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";

export default {
    name: 'ConfigurationDiagram',
    components: { noData, DeviceDetail },
    data() {
        return {
            depId: '', // 当前选中节点ID
            parentHighlighted: null, // 高亮的父节点ID
            treeData: [],
            currentSvgUrl: '', // 当前显示的SVG URL
            updateTimer: null, // 定时器变量
            currentSpaceInfo: {}, // 当前选中的空间信息
            panzoom: null, // panzoom实例
            systemType: '1', // 默认为电力系统
            props: {
                children: 'children',
                label: 'title'
            },
            expandedKeys: [], // 要展开的节点ID数组
            dialogPanzoom: null, // 新增的dialogPanzoom实例
            dialogVisible: false, // Control dialog visibility
            dialogSvgUrl: '', // URL for dialog SVG
            dialogUpdateTimer: null, // 新增弹窗更新定时器
        }
    },
    created() {
        // 优先从路由meta中获取systemType
        if (this.$route.meta && this.$route.meta.systemType) {
            this.systemType = this.$route.meta.systemType;
        }
        // 其次从query参数获取
        else if (this.$route.query.systemType) {
            this.systemType = this.$route.query.systemType;
        }
        // 如果都没有，保持默认值
    },
    mounted() {
        this.getSpaceTreeDataSystemType();

        // 初始化Panzoom
        this.initPanZoom();

        this.$nextTick(() => {
            // 在DOM更新后，手动为顶层节点添加间距
            this.adjustNodeSpacing();
        });
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.updateTimer) {
            clearInterval(this.updateTimer);
        }
        
        // 清除弹窗定时器
        if (this.dialogUpdateTimer) {
            clearInterval(this.dialogUpdateTimer);
        }

        // 销毁panzoom实例
        if (this.panzoom) {
            this.panzoom.dispose();
        }
    },
    methods: {
        // 获取空间树数据
        getSpaceTreeDataSystemType() {
            // 清空现有数据
            this.treeData = [];
            this.depId = '';
            this.currentSvgUrl = '';
            this.expandedKeys = [];

            // 清除定时器
            if (this.updateTimer) {
                clearInterval(this.updateTimer);
                this.updateTimer = null;
            }

            // 使用systemType参数调用API
            getSpaceTreeDataSystemType(this.systemType).then(res => {
                this.treeData = res.data;
                // 如果有数据，默认选中第一个节点
                if (this.treeData && this.treeData.length > 0) {
                    // 如果第一个节点有子节点，添加到展开列表
                    if (this.treeData[0].children && this.treeData[0].children.length > 0) {
                        this.expandedKeys = [this.treeData[0].id];
                    }

                    this.$nextTick(() => {
                        // 设置当前选中节点ID
                        this.depId = this.treeData[0].id;

                        // 调用树组件的setCurrentKey方法确保视觉上的高亮
                        if (this.$refs.tree) {
                            this.$refs.tree.setCurrentKey(this.depId);
                        }

                        // 处理点击事件
                        this.handleNodeClick(this.treeData[0], null);
                    });
                }
            }).catch(err => {
                console.error("获取空间树数据失败:", err);
            });
        },

        // 处理节点点击
        handleNodeClick(data, node) {
            console.log('节点点击:', data, node);
            this.depId = data.id;
            this.currentSpaceInfo = data;

            // 重置先前高亮的父节点
            if (this.parentHighlighted) {
                this.parentHighlighted = null;
            }

            // 如果点击的节点有父级节点，高亮父节点
            if (data.parentId && data.parentId !== '0' && data.parentId !== '10000') {
                this.parentHighlighted = data.parentId;
            }

            // 如果节点有子节点，展开它
            if (data.children && data.children.length > 0) {
                if (!this.expandedKeys.includes(data.id)) {
                    this.expandedKeys.push(data.id);
                }
            }

            // 清除之前的定时器
            if (this.updateTimer) {
                clearInterval(this.updateTimer);
                this.updateTimer = null;
            }

            // 直接使用节点的bgImage属性获取SVG路径
            if (data.bgImage) {
                this.currentSvgUrl = this.$ftpUrl + data.bgImage;
                this.getSvg(this.currentSvgUrl);

                // 重新启动定时器
                this.updateTimer = setInterval(() => {
                    this.updateSvg();
                }, 5000);
            } else {
                console.warn("节点没有bgImage属性");
                this.currentSvgUrl = '';
            }

            // 强制更新视图
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },

        // 获取SVG内容
        getSvg(svgUrl) {
            fetch(svgUrl)
                .then((res) => res.text())
                .then((svgText) => {
                    if (this.$refs.svgContainer) {
                        this.$refs.svgContainer.innerHTML = svgText;

                        // 获取 SVG 元素并设置样式
                        const svgElement = this.$refs.svgContainer.querySelector('svg');
                        if (svgElement) {
                            svgElement.style.width = '100%';
                            svgElement.style.height = '100%';
                            svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
                        }

                        this.initPanZoom();
                    }
                })
                .catch(error => {
                    console.error("加载SVG失败:", error);
                    this.currentSvgUrl = '';
                });
        },

        // 初始化缩放平移功能
        initPanZoom() {
            this.$nextTick(() => {
                if (!this.$refs.svgContainer) {
                    console.warn("svgContainer 还未渲染，无法初始化 Panzoom");
                    return;
                }

                // 销毁之前的实例
                if (this.panzoom) {
                    this.panzoom.dispose();
                }

                // 初始化 panzoom
                this.panzoom = Panzoom(this.$refs.svgContainer, {
                    maxScale: 2,
                    minScale: 0.1,
                    contain: 'outside',
                    canvas: true
                });

                // 自动调整缩放以适应容器
                const container = this.$refs.svgContainer;
                const svg = container.querySelector('svg');
                if (svg) {
                    const containerRect = container.getBoundingClientRect();
                    const svgRect = svg.getBoundingClientRect();

                    // 计算合适的缩放比例
                    const scaleX = containerRect.width / svgRect.width;
                    const scaleY = containerRect.height / svgRect.height;
                    const scale = Math.min(scaleX, scaleY) * 0.9; // 留出一些边距

                    // 应用缩放和居中
                    this.panzoom.zoomTo(0, 0, scale);

                    // 计算居中位置
                    const centerX = (containerRect.width - (svgRect.width * scale)) / 2;
                    const centerY = (containerRect.height - (svgRect.height * scale)) / 2;

                    this.panzoom.moveTo(centerX, centerY);
                }

                this.handleSvg();
                this.updateSvg();
            });
        },

        // 处理SVG中的交互元素
        handleSvg() {
            // 给符合g元素的data-event=click 的元素添加点击事件
            const svgElements = document.querySelectorAll("g[data-event=click]");
            svgElements.forEach((element) => {
                element.style.cursor = "pointer";
                element.addEventListener("click", () => {
                    const deviceId = element.getAttribute("data-deviceid");
                    // 加个鼠标样式
                    this.$refs.deviceDetail.showDeviceDetails(deviceId);
                });
            });

            // 添加svg_click事件处理
            const svgClickElements = document.querySelectorAll("g[data-event=svg_click]");
            svgClickElements.forEach((element) => {
                element.style.cursor = "pointer";
                element.addEventListener("click", () => {
                    // 获取元素上的svgUrl属性
                    const svgUrl = element.getAttribute("data-svgurl") || this.currentSvgUrl;
                    console.log(svgUrl, 'svgUrl');
                    // 加鼠标样式
                    // 弹窗显示SVG
                    this.showSvgDialog( this.$ftpUrl + svgUrl);
                });
            });
        },

        // 更新SVG内容
        async updateSvg(container) {
            // 使用传入的容器或默认使用主SVG容器
            const svg = container || this.$refs.svgContainer;
            if (!svg) return;

            // 1.收集设备ID和测点ID
            const deviceIdElements = svg.querySelectorAll("g[data-deviceid]");
            const deviceIds = Array.from(deviceIdElements).map(
                (element) => element.dataset.deviceid
            );
            const pointidElements = svg.querySelectorAll("g[data-pointid]");
            const pointids = Array.from(pointidElements).map(
                (element) => element.dataset.pointid
            );

            if (deviceIds.length === 0 && pointids.length === 0) return;

            // 获取数据
            const idsObj = await this.getIdsReturnValue({
                deviceIds,
                pointids,
            });

            // 2.处理设备状态
            idsObj.deviceIds.forEach((item) => {
                const currentStatus = item.status;
                const currentDeviceId = item.deviceid;
                Array.from(deviceIdElements).forEach((element) => {
                    if (currentDeviceId == element.dataset.deviceid) {
                        element.style.display = "block";
                        if (element.dataset.status) {
                            if (currentStatus == '-2') {
                                if (element.dataset.status == "0") {
                                    element.style.display = "none";
                                }
                                this.updateElementColor(element, 'green')
                            } else {
                                if (element.dataset.status == "0" && currentStatus == "1") {
                                    element.style.display = "none";
                                } else if (
                                    element.dataset.status == "1" &&
                                    currentStatus == "0"
                                ) {
                                    element.style.display = "none";
                                }
                            }
                        } else {
                            if (currentStatus == "1") {
                                this.updateElementColor(element, 'green')
                            } else {
                                this.updateElementColor(element, 'red')
                            }
                        }
                    }
                });
            });

            // 3.分类处理不同元素
            const textArr = [];
            const tempArr = [];
            const LineArr = [];
            const switchArr = [];

            // 分组处理
            const pointidGroups = {};
            Array.from(pointidElements).forEach((element) => {
                const pointid = element.dataset.pointid;
                if (!pointidGroups[pointid]) {
                    pointidGroups[pointid] = [];
                }
                pointidGroups[pointid].push(element);
            });

            // 区分text框和其他元素
            Object.entries(pointidGroups).forEach(([pointid, elements]) => {
                if (elements.length === 1) {
                    textArr.push({
                        element: elements[0],
                        pointid,
                    });
                } else {
                    tempArr.push({
                        elements,
                        pointid,
                    });
                }
            });

            // 区分开关闸和线
            tempArr.forEach((group) => {
                const switchElements = group.elements.filter(el =>
                    el.dataset.value == '0' || el.dataset.value == '1'
                );

                const lineElements = group.elements.filter(el =>
                    el.dataset.value !== '0' && el.dataset.value !== '1'
                );

                if (switchElements.length > 0) {
                    switchArr.push({
                        ...group,
                        elements: switchElements
                    });
                }

                if (lineElements.length > 0) {
                    LineArr.push({
                        ...group,
                        elements: lineElements
                    });
                }
            });

            // 4.处理各类元素
            // 处理text框
            textArr.forEach((item) => {
                const pointInfo = idsObj.pointids.find(
                    (p) => p.pointid === item.pointid
                );
                if (pointInfo) {
                    const foreignObjects = item.element.querySelectorAll("foreignObject");
                    foreignObjects.forEach((foreignObject) => {
                        const divs = Array.from(
                            foreignObject.querySelectorAll("div")
                        ).filter((div) => div.parentElement !== foreignObject);

                        divs.forEach((div) => {
                            const originalColor = div.style.color || "black";
                            div.textContent = `${pointInfo.pointName}：${pointInfo.pointValueName}`;
                            div.style.color = originalColor;
                            div.style.fontSize = '7px';
                        });
                    });
                }
            });

            // 处理开关闸
            switchArr.forEach((group) => {
                idsObj.pointids.forEach((item) => {
                    const currentValue = item.pointValue;
                    const currentPointId = item.pointid;

                    group.elements.forEach((element) => {
                        element.style.display = "block";
                        if (currentPointId == element.dataset.pointid) {
                            if (element.dataset.value == "0" && currentValue == "1") {
                                element.style.display = "none";
                            } else if (element.dataset.value == "1" && currentValue == "0") {
                                element.style.display = "none";
                            }

                            const color = currentValue == "0" ? 'green' : 'red';
                            this.updateElementColor(element, color);
                        }
                    });
                });
            });

            // 处理线
            LineArr.forEach((group) => {
                const pointInfo = idsObj.pointids.find(
                    (p) => p.pointid === group.pointid
                );
                if (pointInfo) {
                    group.elements.forEach((element) => {
                        // 根据point的值改变线的状态
                        if (pointInfo.pointValue == "1") {
                            this.updateElementColor(element, 'green')
                        } else {
                            this.updateElementColor(element, 'green')
                        }
                    });
                }
            });
        },

        // 新增方法：显示SVG弹窗
        showSvgDialog(svgUrl) {
            this.dialogSvgUrl = svgUrl;
            this.dialogVisible = true;
            
            // 清除可能存在的旧定时器
            if (this.dialogUpdateTimer) {
                clearInterval(this.dialogUpdateTimer);
                this.dialogUpdateTimer = null;
            }
            
            // Load SVG after dialog is visible
            this.$nextTick(() => {
                // Wait for DOM update before initializing the SVG
                this.$nextTick(() => {
                    const container = this.$refs.dialogSvgContainer;
                    if (container) {
                        fetch(svgUrl)
                            .then(res => res.text())
                            .then(svgText => {
                                container.innerHTML = svgText;
                                
                                // Get and set SVG style
                                const svgElement = container.querySelector('svg');
                                if (svgElement) {
                                    svgElement.style.width = '100%';
                                    svgElement.style.height = '100%';
                                    svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
                                    
                                    // Initialize panzoom for the dialog SVG
                                    this.initDialogPanZoom(container);
                                    
                                    // 处理SVG交互元素
                                    this.handleSvg();
                                    // 立即更新一次
                                    this.updateSvg(container);
                                    
                                    // 创建定时更新的定时器 - 与主视图使用相同的更新频率
                                    this.dialogUpdateTimer = setInterval(() => {
                                        this.updateSvg(container);
                                    }, 5000); // 5秒更新一次
                                }
                            })
                            .catch(error => {
                                console.error("加载SVG失败:", error);
                                container.innerHTML = '<div style="color:red;">SVG加载失败</div>';
                            });
                    }
                });
            });
        },

        // 新增方法：为弹窗SVG初始化panzoom功能
        initDialogPanZoom(container) {
            if (this.dialogPanzoom) {
                this.dialogPanzoom.dispose();
            }

            this.dialogPanzoom = Panzoom(container, {
                maxScale: 4,
                minScale: 0.1,
                contain: 'inside',
                canvas: true
            });

            container.addEventListener('wheel', e => {
                e.preventDefault();
                const delta = e.deltaY;
                
                if (this.dialogPanzoom) {
                    const scale = this.dialogPanzoom.getScale();
                    const newScale = delta > 0 ? scale * 0.9 : scale * 1.1;
                    const limitedScale = Math.min(newScale, 4);
                    this.dialogPanzoom.zoomTo(e.clientX, e.clientY, limitedScale);
                }
            });

            const svg = container.querySelector('svg');
            if (svg) {
                const containerRect = container.getBoundingClientRect();
                const svgRect = svg.getBoundingClientRect();

                const scaleX = containerRect.width / svgRect.width;
                const scaleY = containerRect.height / svgRect.height;
                const scale = Math.min(scaleX, scaleY) * 0.9; 
                this.dialogPanzoom.zoomTo(0, 0, scale);

                const centerX = (containerRect.width - (svgRect.width * scale)) / 2;
                const centerY = (containerRect.height - (svgRect.height * scale)) / 2;

                this.dialogPanzoom.moveTo(centerX, centerY);
            }
        },

        // 通过id数组获取对应的测点值
        getIdsReturnValue(obj) {
            return new Promise((resolve) => {
                getDataByDeviceIdsAndPointIds(obj.deviceIds, obj.pointids)
                    .then(res => {
                        // 检查返回数据是否有效
                        if (!res || !res.data) {
                            console.error('返回数据无效');
                            resolve({
                                deviceIds: [],
                                pointids: []
                            });
                            return;
                        }

                        const idsObj = res.data;

                        // 构造返回数据结构
                        const result = {
                            deviceIds: idsObj.devicesList.map(item => ({
                                deviceid: item.id,
                                status: item.status,
                                deviceName: item.deviceName || ''
                            })),
                            pointids: idsObj.pointsLists.map(item => ({
                                pointid: item.pointId,
                                pointValue: item.pointValue,
                                pointName: item.pointName,
                                pointUnit: item.pointUnit,
                                pointValueName: item.pointValueName
                            }))
                        };

                        // 返回处理后的数据
                        resolve(result);
                    })
                    .catch(error => {
                        console.error('获取设备和测点数据失败:', error);
                        resolve({
                            deviceIds: [],
                            pointids: []
                        });
                    });
            });
        },

        // 获取元素字体大小
        getFontSize(element) {
            let fontSize = element.style.fontSize || "9px"; // 默认 9px

            // 如果没有行内样式，检查父元素
            if (!fontSize || fontSize === "0px") {
                const computedStyle = getComputedStyle(element);
                fontSize = computedStyle.fontSize || "9px";

                // 如果 computedStyle 中也没有字体大小，递归检查父元素
                if (fontSize === "0px" && element.parentElement) {
                    return this.getFontSize(element.parentElement);
                }
            }

            return fontSize;
        },

        // 更新SVG元素颜色
        updateElementColor(element, newColor, options = {}) {
            const {
                updateFill = true,
                updateStroke = true
            } = options;

            // 获取元素的计算样式
            const style = window.getComputedStyle(element);

            // 更新fill
            if (updateFill && style.fill && style.fill !== 'none') {
                element.style.fill = newColor;
            }

            // 更新stroke
            if (updateStroke && style.stroke && style.stroke !== 'none') {
                element.style.stroke = newColor;
            }

            // 递归处理所有子元素
            Array.from(element.children).forEach(child => {
                this.updateElementColor(child, newColor, options);
            });
        },

        // 自定义节点渲染函数
        renderContent(h, { node, data, store }) {
            console.log(store);
            // 检查节点是否为选中节点的父节点
            const isParentOfSelected = this.parentHighlighted === data.id;
            // 检查是否为顶层父节点
            const isTopLevelParent = data.parentId === '10000';

            // 添加样式对象
            const style = isTopLevelParent ? {
                marginTop: '15px',
                marginBottom: '15px'
            } : {};

            // 添加额外的类以高亮父节点
            const className = isParentOfSelected ? 'parent-highlighted' : '';

            return h('span', {
                class: className,
                style: style,
                domProps: {
                    innerHTML: node.label
                }
            });
        },

        // 手动调整节点间距
        adjustNodeSpacing() {
            // 获取所有顶层节点
            const topLevelNodes = this.$el.querySelectorAll('#tree > .el-tree-node');

            topLevelNodes.forEach((node, index) => {
                // 为每个顶层节点添加间距
                if (index > 0) { // 从第二个节点开始添加顶部边距
                    node.style.marginTop = '20px';
                }

                // 获取节点内的span元素
                const span = node.querySelector('.el-tree-node__content > span:last-of-type');
                if (span) {
                    span.style.marginTop = '15px';
                    span.style.marginBottom = '15px';
                }
            });
        },

        // 处理对话框关闭
        handleDialogClose() {
            // 清除弹窗更新定时器
            if (this.dialogUpdateTimer) {
                clearInterval(this.dialogUpdateTimer);
                this.dialogUpdateTimer = null;
            }
            
            // Clean up panzoom when closing the dialog
            if (this.dialogPanzoom) {
                this.dialogPanzoom.dispose();
                this.dialogPanzoom = null;
            }
            
            // Clear the SVG container
            if (this.$refs.dialogSvgContainer) {
                this.$refs.dialogSvgContainer.innerHTML = '';
            }
            
            this.dialogVisible = false;
            return true;
        }
    },
    watch: {
        '$route': {
            immediate: true,
            handler(to) {
                let newSystemType;

                // 首先检查meta
                if (to.meta && to.meta.systemType) {
                    newSystemType = to.meta.systemType;
                }
                // 其次检查query
                else if (to.query.systemType) {
                    newSystemType = to.query.systemType;
                }

                if (newSystemType && newSystemType !== this.systemType) {
                    this.systemType = newSystemType;
                    this.getSpaceTreeDataSystemType();
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#tree {
    background: transparent !important;
    color: #fff;
    font-size: 14px;

    // 选中节点的样式 - 更改为#0098FF
    ::v-deep .is-current>.el-tree-node__content {
        background-color: transparent !important;

        &>.el-tree-node__label,
        &>span {
            color: #0098FF !important;
            font-weight: bold;
        }
    }

    // 高亮父节点样式
    ::v-deep .parent-highlighted {
        color: #0098FF !important;
        font-weight: bold;
    }

    // 尝试使用更强的选择器来设置间距
    ::v-deep>.el-tree-node {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    // 为第一个父节点添加上边距
    ::v-deep>.el-tree-node:first-child {
        margin-top: 10px !important;
    }

    // 默认为最外层父节点的文本span添加背景色
    ::v-deep>.el-tree-node>.el-tree-node__content>span:last-of-type {
        position: relative;
        display: flex;
        /* 改为flex布局 */
        justify-content: center;
        /* 水平居中 */
        align-items: center;
        /* 垂直居中 */
        min-width: 120px;
        background: url('../../assets/images/treebtn.png');
        background-size: 100% 100%;

        margin: 20px 0;
        padding: 5px 0;
        /* 清除可能的内边距 */
    }

    // 确保文本垂直居中且样式正确
    ::v-deep>.el-tree-node>.el-tree-node__content>span:last-of-type>span {
        display: block;
        line-height: normal;
        /* 重置行高 */
        padding: 0;
        /* 清除内边距 */
    }

    // 最外层父节点被选中时的文本span样式
    ::v-deep>.el-tree-node.is-current>.el-tree-node__content>span:last-of-type {
        background-color: rgba(0, 152, 255, 0.15);
        --h: 31px;
        clip-path: polygon(0 0,
                calc(100% - calc(var(--h) / 2)) 0,
                100% calc(var(--h) / 2),
                calc(100% - calc(var(--h) / 2)) 100%,
                0 100%);
    }

    ::v-deep .el-tree-node__content {
        padding: 0 !important;
        margin: 4px 0;
        /* 为所有节点内容添加少量上下间距 */
    }

    ::v-deep .el-tree-node {
        position: relative;
        padding-left: 16px;
    }

    ::v-deep .el-tree-node__children {
        padding-left: 16px;
    }

    // 竖线
    ::v-deep .el-tree-node::before {
        content: "";
        height: 100%;
        width: 1px;
        position: absolute;
        left: -3px;
        top: -26px;
        border-width: 1px;
        border-left: 1px dashed #99A6B1;
    }

    ::v-deep .el-tree-node:last-child::before {
        height: 38px;
    }

    // 横线
    ::v-deep .el-tree-node::after {
        content: "";
        width: 24px;
        height: 20px;
        position: absolute;
        left: -3px;
        top: 12px;
        border-width: 1px;
        border-top: 1px dashed #99A6B1;
    }

    ::v-deep &>.el-tree-node::after {
        border-top: none;
    }

    ::v-deep &>.el-tree-node::before {
        border-left: none;
    }

    // 隐藏所有展开图标
    ::v-deep .el-tree-node__expand-icon {
        visibility: hidden; // 默认隐藏所有箭头
    }

    // 只显示最外层节点的展开图标
    ::v-deep>.el-tree-node>.el-tree-node__content>.el-tree-node__expand-icon {
        visibility: visible !important; // 强制显示最外层节点的箭头
        font-size: 16px;
        color: #0098FF;
        cursor: pointer;
    }

    // 确保最外层节点箭头在所有状态下都可见
    ::v-deep>.el-tree-node.is-expanded>.el-tree-node__content>.el-tree-node__expand-icon {
        visibility: visible !important;
    }

    // 确保hover时背景色为透明
    ::v-deep .el-tree-node__content:hover {
        background-color: transparent !important;
    }

    // 防止子节点内容hover时显示背景色
    ::v-deep .el-tree-node__children .el-tree-node__content:hover {
        background-color: transparent !important;
    }

    ::v-deep .el-tree-node:focus>.el-tree-node__content {
        background-color: transparent;
    }
}

::v-deep #tree .el-tree-node__children {
    padding-left: 40px;
}

// 添加全局样式
::v-deep .el-tree>.el-tree-node {
    margin-bottom: 15px !important;
}

// 修复全局hover样式 - 确保正确使用深度选择器
::v-deep .el-tree-node__content:hover {
    background-color: transparent !important;
}

::v-deep .el-upload-list__item:hover {
    background-color: transparent !important;
}

.configuration-diagram {
    display: flex;

    .left {
        margin: 20px 10px;
        width: 233px;
        height: calc(100vh - 55px);
        background: rgba(9, 69, 123, 0.1);
        border-radius: 2px 2px 2px 2px;
        border: 1px solid rgba(41, 155, 255, 0.1);
        padding-top: 15px;
        /* 为整个树容器添加顶部内边距 */
    }

    .right {
        width: calc(100% - 253px);
        height: calc(100vh - 55px);
        overflow: hidden;
        margin: 20px 0;
        position: relative;

        .svg-wrapper {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            position: relative;

            svg {
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }
    }
}

.main {
    width: 100%;
    overflow: hidden;
    height: calc(100vh - 90px);
}

::v-deep .svg-dialog-large {
    max-width: 1400px;
}

::v-deep .svg-dialog-large .el-dialog__body {
    padding: 10px;
    height: 650px;
    overflow: hidden;
}
</style>
